import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import NextArrow from './NextArrow';
import PrevArrow from './PrevArrow';


export default class Carousel extends PureComponent {

    render() {
        return (
            <Slider {...this.props}>
                {this.props.children}
            </Slider>
        );
    }
}

Carousel.propTypes = {
    children: PropTypes.array.isRequired
};

Carousel.defaultProps = {
    className: 'center',
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    adaptiveHeight: false,
    infinite: false,
    swipe: true,
    swipeToSlide: true,
    speed: 500
};
